<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton && actionType === 'save' || 'add'"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            :message="$t('Customer\'s account name or account number or customer id is required')"
          />
          <b-col md="12">
            <InputField
              id="customer-id"
              v-model="searchParams.customerID"
              :label="$t('Customer ID')"
              :placeholder="$t('Enter customer Id')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
            />
          </b-col>

          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              :label="$t('Reference Number')"
              :placeholder="$t('Enter reference number')"
              type="text"
            />
          </b-col>

          <b-col md="12">
            <Button
              :label="$t('Search')"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>

      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <app-collapse
            class="business-items mb-4"
            type="margin"
            accordion
          >
            <app-collapse-item
              :title="$t('Account Summary')"
              class="card-item"
              is-visible
            >
              <b-row>
                <b-col md="4">
                  <InputField
                    id="account-name"
                    v-model="customer.accountName"
                    :label="$t('Account Name')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="4">
                  <InputField
                    id="account-number"
                    v-model="customer.accountNumber"
                    :label="$t('Account Number')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="4">
                  <InputField
                    id="branch"
                    v-model="customer.branchName"
                    :label="$t('Branch')"
                    type="text"
                    readonly
                  />
                </b-col>

                <b-col md="4">
                  <InputField
                    id="account-status"
                    v-model="customer.accountStatus"
                    :label="$t('Account Status')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="available-balance"
                    v-model="customer.availableBalance"
                    :label="$t('Available Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="withdrawable-balance"
                    v-model="customer.withdrawableBalance"
                    :label="$t('Withdrawable Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
              </b-row>
            </app-collapse-item>
          </app-collapse>
          <b-row>
            <b-col
              md="6"
              class="mb-5"
            >
              <SelectField
                id="bills-type"
                v-model="billsType"
                :label="$t('Bills Type')"
                rules="required"
                :error-name="$t('Bills Type')"
                :reduce="option => option.value"
                :options="billTypeOptions"
                item="label"
                :placeholder="$t('Select Bills Type')"
                :set-selected="setBillersCategory"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-for="(biller, index) in selectedBillers.flat()"
              :key="index"
              md="4"
            >
              <b-card
                class="mb-3 format-cards"
                @click="fetchBillerPackage(biller.billType, biller.name, biller.identifier, biller.packages)"
              >
                <div class="card-inner">
                  <b-img
                    :src="biller.logoUrl ? biller.logoUrl : logo"
                    :alt="`${biller.name}'s logo`"
                    class="brand-logo"
                  />
                </div>
                <div>
                  <b-card-text>
                    <p class="card-title">
                      {{ biller.name }}
                    </p>
                    <p class="card-subtitle">
                      {{ biller.identifier }}
                    </p>
                  </b-card-text>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>

    </b-modal>

    <b-modal
      id="bills-payment-modal"
      ref="bills-payment-modal"
      no-close-on-backdrop
      cancel-variant="outline-secondary"
      centered
      size="md"
      :title="$t('Bills Payment')"
      @ok="checkCustomerBillsPayment"
      @hidden="resetAirtimeData"
    >
      <div v-if="billerType === 'Airtime'">
        <h3
          class="mb-3"
          style="font-family: Century Gothic, sans-serif; font-size: 1.5rem; font-weight: bold;"
        >
          {{ billerName }}
        </h3>
        <validation-observer ref="makeBillsPayRules">
          <b-row>
            <b-col
              v-if="!billerType === 'Airtime'"
              md="12"
            >
              <SelectField
                id="package"
                v-model="billsPaymentFormData.packageIdentifier"
                :label="`${billerName} ${$t('Packages')}`"
                rules="required"
                :error-name="$t('Packages')"
                :reduce="option => option.value"
                :options="packageOptions"
                item="label"
                :placeholder="$t('Select Packages')"
                :set-selected="setBillsPackageValue"
              />
            </b-col>
            <b-col md="12">
              <InputNumberField
                id="amount"
                v-model="billsPaymentFormData.amount"
                :label="$t('Amount')"
                type="number"
                :error-name="$t('Amount')"
                rules="required|positive"
                @input="checkAmountValue(billsPaymentFormData.amount)"
              />
            </b-col>
            <b-col md="12">
              <InputField
                id="phone-number"
                v-model="billsPaymentFormData.customerId"
                :label="$t('Phone Number')"
                type="number"
                :error-name="$t('Phone Number')"
                rules="required|integer|positive|max:11|min:11"
              />
            </b-col>
          </b-row>
        </validation-observer>
      </div>
      <div v-if="billerType === 'Electricity'">
        <h3
          class="mb-3"
          style="font-family: Century Gothic, sans-serif; font-size: 1.5rem; font-weight: bold;"
        >
          {{ billerName }}
        </h3>
        <validation-observer ref="makeBillsPayRules">
          <b-row>
            <b-col md="12">
              <SelectField
                id="package"
                v-model="billsPaymentFormData.packageIdentifier"
                :label="`${billerName} ${$t('Packages')}`"
                rules="required"
                :error-name="$t('Packages')"
                :reduce="option => option.value"
                :options="packageOptions"
                item="label"
                :placeholder="$t('Select Packages')"
                :set-selected="setBillsPackageValue"
              />
            </b-col>
            <b-col md="12">
              <InputNumberField
                id="amount"
                v-model="billsPaymentFormData.amount"
                :label="$t('Amount')"
                type="number"
                :error-name="$t('Amount')"
                rules="required|positive"
                @input="checkAmountValue"
              />
            </b-col>
            <b-col md="12">
              <InputField
                id="meter-number"
                v-model="billsPaymentFormData.customerId"
                :label="$t('Meter Number')"
                type="number"
                :error-name="$t('Meter Number')"
                rules="required"
              />
            </b-col>
          </b-row>
        </validation-observer>
      </div>
      <div v-if="billerType === 'Betting'">
        <h3
          class="mb-3"
          style="font-family: Century Gothic, sans-serif; font-size: 1.5rem; font-weight: bold;"
        >
          {{ billerName }}
        </h3>
        <validation-observer ref="makeBillsPayRules">
          <b-row>
            <b-col md="12">
              <SelectField
                id="package"
                v-model="billsPaymentFormData.packageIdentifier"
                :label="`${billerName} ${$t('Packages')}`"
                rules="required"
                :error-name="$t('Packages')"
                :reduce="option => option.value"
                :options="packageOptions"
                item="label"
                :placeholder="$t('Select Packages')"
                :set-selected="setBillsPackageValue"
              />
            </b-col>
            <b-col md="12">
              <InputNumberField
                id="amount"
                v-model="billsPaymentFormData.amount"
                :label="$t('Amount')"
                type="number"
                :error-name="$t('Amount')"
                rules="required|positive"
                @input="checkAmountValue"
              />
            </b-col>
            <b-col md="12">
              <InputField
                id="user-id"
                v-model="billsPaymentFormData.customerId"
                :label="$t('User ID')"
                type="text"
                :error-name="$t('User ID')"
                rules="required"
              />
            </b-col>
          </b-row>
        </validation-observer>
      </div>
      <div v-if="billerType === 'Internet'">
        <h3
          class="mb-3"
          style="font-family: Century Gothic, sans-serif; font-size: 1.5rem; font-weight: bold;"
        >
          {{ billerName }}
        </h3>
        <validation-observer ref="makeBillsPayRules">
          <b-row>
            <b-col md="12">
              <SelectField
                id="package"
                v-model="billsPaymentFormData.packageIdentifier"
                :label="`${billerName} ${$t('Packages')}`"
                rules="required"
                :error-name="$t('Packages')"
                :reduce="option => option.value"
                :options="packageOptions"
                item="label"
                :placeholder="$t('Select Packages')"
                :set-selected="setBillsPackageValue"
              />
            </b-col>
            <b-col md="12">
              <InputNumberField
                id="amount"
                v-model="billsPaymentFormData.amount"
                :label="$t('Amount')"
                type="number"
                :error-name="$t('Amount')"
                rules="required|positive"
                readonly
                @input="checkAmountValue"
              />
            </b-col>
            <b-col md="12">
              <InputField
                id="phone-number"
                v-model="billsPaymentFormData.customerId"
                :label="$t('Phone Number')"
                type="number"
                :error-name="$t('Phone Number')"
                rules="required|integer|positive|min:11|max:11"
              />
            </b-col>
          </b-row>
        </validation-observer>
      </div>
      <div v-if="billerType === 'Collections'">
        <h3
          class="mb-3"
          style="font-family: Century Gothic, sans-serif; font-size: 1.5rem; font-weight: bold;"
        >
          {{ billerName }}
        </h3>
        <validation-observer ref="makeBillsPayRules">
          <b-row>
            <b-col md="12">
              <SelectField
                id="package"
                v-model="billsPaymentFormData.packageIdentifier"
                :label="`${billerName} ${$t('Packages')}`"
                rules="required"
                :error-name="$t('Packages')"
                :reduce="option => option.value"
                :options="packageOptions"
                item="label"
                :placeholder="$t('Select Packages')"
                :set-selected="setBillsPackageValue"
              />
            </b-col>
            <b-col md="12">
              <InputNumberField
                id="amount"
                v-model="billsPaymentFormData.amount"
                :label="$t('Amount')"
                type="number"
                :error-name="$t('Amount')"
                rules="required|positive"
                readonly
                @input="checkAmountValue"
              />
            </b-col>
            <b-col md="12">
              <InputField
                id="user-id"
                v-model="billsPaymentFormData.customerId"
                :label="$t('User ID')"
                type="number"
                :error-name="$t('User ID')"
                rules="required"
              />
            </b-col>
          </b-row>
        </validation-observer>
      </div>
      <div v-if="billerType === 'CableTv'">
        <h3
          class="mb-3"
          style="font-family: Century Gothic, sans-serif; font-size: 1.5rem; font-weight: bold;"
        >
          {{ billerName }}
        </h3>
        <validation-observer ref="makeBillsPayRules">
          <b-row>
            <b-col md="12">
              <SelectField
                id="package"
                v-model="billsPaymentFormData.packageIdentifier"
                :label="`${billerName} ${$t('Packages')}`"
                rules="required"
                :error-name="$t('Packages')"
                :reduce="option => option.value"
                :options="packageOptions"
                item="label"
                :placeholder="$t('Select Packages')"
                :set-selected="setBillsPackageValue"
              />
            </b-col>
            <b-col md="12">
              <InputNumberField
                id="amount"
                v-model="billsPaymentFormData.amount"
                :label="$t('Amount')"
                type="number"
                :error-name="$t('Amount')"
                rules="required|positive"
                readonly
                @input="checkAmountValue"
              />
            </b-col>
            <b-col md="12">
              <InputField
                id="smart-card-number"
                v-model="billsPaymentFormData.customerId"
                :label="$t('IUC/Smartcard Number')"
                type="number"
                :error-name="$t('IUC/Smartcard Number')"
                rules="required"
              />
            </b-col>
          </b-row>
        </validation-observer>
      </div>
      <div class="button-center mt-4">
        <div>
          <Button
            v-if="billerType === 'Airtime' || billerType === 'Internet'"
            :label="$t('Continue')"
            :loading="isLoading"
            :disabled="!isInsufficientFund"
            size="lg"
            @click="onViewSignatoryMandate"
          />
          <Button
            v-else
            :label="$t('Next')"
            :loading="isLoading"
            :disabled="!isInsufficientFund"
            size="lg"
            @click="onViewSignatoryMandate"
          />
        </div>
      </div>
      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
      <FullScreenSpinner :show="showSpinner" />
    </b-modal>
    <b-modal
      id="confirm-bills-payment-modal"
      ref="confirm-bills-payment-modal"
      no-close-on-backdrop
      cancel-variant="outline-secondary"
      centered
      size="md"
      :title="$t('Bills Payment Details')"
      @ok="handleBillsPayment"
      @hidden="resetPackageIdentifier"
    >
      <div>
        <validation-observer ref="makeBillsPayRules">
          <b-row>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('Biller') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ billerName }}
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('Package') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ billerPackage }}
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('Amount') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ toBalance(billsPaymentFormData.amount * 100) }}
            </b-col>
          </b-row>
          <b-row v-if="billerType === 'Collections'">
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('User ID') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ billsPaymentFormData.customerId }}
            </b-col>
          </b-row>
          <b-row v-else-if="billerType === 'CableTv'">
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('IUC/Smartcard Number') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ billsPaymentFormData.customerId }}
            </b-col>
          </b-row>
          <b-row v-else-if="billerType === 'Electricity'">
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('Meter Number') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ billsPaymentFormData.customerId }}
            </b-col>
          </b-row>
          <b-row v-else-if="billerType === 'Betting'">
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('User ID') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ billsPaymentFormData.customerId }}
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-start mb-2"
            >
              {{ $t('Customer Name') }}
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-end mb-2"
            >
              {{ billsPaymentFormData.customerName }}
            </b-col>
          </b-row>
          <div class="button-center mt-4">
            <div>
              <Button
                :label="$t('Continue')"
                :loading="isLoading"
                :disabled="!isInsufficientFund"
                size="lg"
                @click="handleBillsPayment"
              />
            </div>
          </div>
        </validation-observer>
      </div>
      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
      <FullScreenSpinner :show="showSpinner" />
    </b-modal>

    <b-modal
      v-if="billerType === 'Airtime' || billerType === 'Internet'"
      id="signatory-mandate-table"
      ref="signatoryMandateTable"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      :ok-title="$t('Proceed')"
      centered
      size="lg"
      :ok-disabled="hasSelectedSignatory"
      :title="$t('Signatory Mandate')"
      @ok="handleBillsPayment"
    >
      <b-tabs>
        <b-tab
          :title="$t('Account Signatories')"
          active
        >

          <b-table
            ref="signatoryTable"
            select-mode="single"
            :items="signatoryList"
            responsive
            :fields="translatedSignatoryListHeader"
            :per-page="perPage"
            :current-page="currentPage"
            primary-key="id"
            show-empty
            :empty-text="$t('No result found')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative mt-2"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>

            <template #cell(select)="data">
              <b-form-group class="mt-1">
                <b-form-checkbox
                  v-model="data.item.select"
                  @change="onSelect"
                />
              </b-form-group>
            </template>

            <template #cell(passport)="data">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="32"
                    :src="data.item.passport"
                    button
                    @click="onViewPassport(data.item.passport, data.item.fullName)"
                  />
                </template>
              </b-media>
            </template>

            <template #cell(signature)="data">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="32"
                    :src="data.item.signature"
                    button
                    @click="onViewSignature(data.item.signature, data.item.fullName)"
                  />
                </template>
              </b-media>
            </template>
          </b-table>

        </b-tab>

        <b-tab
          :title="$t('Mandate Information')"
        >
          <b-table
            ref="mandateListTable"
            select-mode="single"
            :items="mandateList"
            responsive
            :fields="translatedMandateListHeaders"
            primary-key="id"
            selectable
            show-empty
            :empty-text="$t('No data available')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>
            <template #cell(isLimited)="data">
              {{ data.value === false ? 'Unlimited' : 'Limited' }}
            </template>
            <template #cell(amount)="data">
              {{ data.value === 0 ? 'Unlimited' : toBalance(data.value) }}
            </template>
          </b-table>

        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal
      v-else
      id="signatory-mandate-table"
      ref="signatoryMandateTable"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      :ok-title="$t('Proceed')"
      centered
      size="lg"
      :ok-disabled="hasSelectedSignatory"
      :title="$t('Signatory Mandate')"
      @ok="checkCustomerBillsPayment"
    >
      <b-tabs>
        <b-tab
          :title="$t('Account Signatories')"
          active
        >

          <b-table
            ref="signatoryTable"
            select-mode="single"
            :items="signatoryList"
            responsive
            :fields="translatedSignatoryListHeader"
            :per-page="perPage"
            :current-page="currentPage"
            primary-key="id"
            show-empty
            :empty-text="$t('No result found')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative mt-2"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>

            <template #cell(select)="data">
              <b-form-group class="mt-1">
                <b-form-checkbox
                  v-model="data.item.select"
                  @change="onSelect"
                />
              </b-form-group>
            </template>

            <template #cell(passport)="data">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="32"
                    :src="data.item.passport"
                    button
                    @click="onViewPassport(data.item.passport, data.item.fullName)"
                  />
                </template>
              </b-media>
            </template>

            <template #cell(signature)="data">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="32"
                    :src="data.item.signature"
                    button
                    @click="onViewSignature(data.item.signature, data.item.fullName)"
                  />
                </template>
              </b-media>
            </template>
          </b-table>

        </b-tab>

        <b-tab
          :title="$t('Mandate Information')"
        >
          <b-table
            ref="mandateListTable"
            select-mode="single"
            :items="mandateList"
            responsive
            :fields="translatedMandateListHeaders"
            primary-key="id"
            selectable
            show-empty
            :empty-text="$t('No data available')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>
            <template #cell(isLimited)="data">
              {{ data.value === false ? 'Unlimited' : 'Limited' }}
            </template>
            <template #cell(amount)="data">
              {{ data.value === 0 ? 'Unlimited' : toBalance(data.value) }}
            </template>
          </b-table>

        </b-tab>
      </b-tabs>
    </b-modal>

    <b-modal
      id="avatar-modal"
      ref="avatarModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="avatarModalTitle"
      @hidden="resetAvatarModal"
      @cancel="resetAvatarModal"
    >

      <div class="m-2 text-center">

        <b-row>
          <b-col cols="12">
            <b-img
              v-if="avatarLg"
              :src="avatarLg"
              :alt="avatarModalTitle"
              fluid
            />
            <b-avatar
              v-else
              size="30rem"
              :src="avatarLg"
            />
          </b-col>

        </b-row>

      </div>

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="memo-info-modal"
      ref="memoInfoModal"
      :ok-title="$t('Cancel')"
      ok-only
      :title="$t('Memo')"
      ok-variant="outline-secondary"
      centered
      no-close-on-backdrop
      size="lg"
    >
      <b-table
        ref="memoListTable"
        select-mode="single"
        :items="memoGetData"
        responsive
        :fields="translatedMemoListHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No data available')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>
    </b-modal>

    <!-- <FullScreenSpinner :show="showSpinner" /> -->
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable, BCardText, BImg, BMedia, BAvatar, BFormGroup, BFormCheckbox, BTabs, BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { v4 as uuidv4 } from 'uuid'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance, toKobo, formatAmount } from '@/helpers/formatAmount'
import InputField from '../../../forms/InputField.vue'
import InputNumberField from '../../../forms/InputNumberField.vue'
import SelectField from '../../../forms/SelectField.vue'
import Button from '../../../components/button/Button.vue'
import Alert from '../../../components/alert/Alert.vue'
import removeUnderscore from '@/helpers/convertUppercase'
import { transformMandateRule } from '@/helpers/transformers'
import textLogo from '../../../../../public/logo2.png'

export default {
  components: {
    BRow,
    BCol,
    InputField,
    InputNumberField,
    SelectField,
    Button,
    TablePagination,
    Alert,
    BTable,
    BCard,
    BImg,
    BCardText,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    BMedia,
    BAvatar,
    BFormGroup,
    BFormCheckbox,
    BTabs,
    BTab,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      logo: textLogo,
      // removeUnderscore,
      toBalance,
      actionType: 'save',
      isDisabled: false,
      isLoading: false,
      isInsufficientFund: false,
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      sortBy: 'accountName',
      searchParams: {
        accountNumber: null,
        accountName: null,
        customerID: null,
        referenceNumber: null,
      },
      customerList: [],
      customer: {
        accountName: '',
        accountNumber: '',
        branchName: '',
        accountStatus: '',
        availableBalance: '',
        withdrawableBalance: '',
        originalWithdrawableBalance: '',
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
      ],
      billTypeOptions: [],
      packageOptions: [],
      selectedPackages: [],
      allBillers: [],
      selectedBillers: [],
      billerId: '',
      billerType: '',
      billerName: '',
      billsType: '',
      filteredBillerName: '',
      orignalfilteredBillerName: '',
      getPackageIdentifier: '',
      billerPackage: '',
      billsPaymentFormData: {
        paymentReference: '',
        customerId: '',
        packageIdentifier: '',
        billerIdentifier: '',
        amount: 0,
        accountNumber: '',
        transactionChannel: 3,
        customerName: '',
      },
      allBillsPaymentData: {},

      avatarLg: '',
      avatarModalTitle: '',
      selectedSignatories: [],
      selected: [],
      signatoryList: [],
      signatoryMandateList: [],
      mandateList: [],
      mandateListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'rule', sortable: true, label: 'Rule' },
        { key: 'isLimited', sortable: true, label: 'limit' },
        { key: 'amount', sortable: true, label: 'Amount' },
      ],
      signatoryListHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'select', label: 'Select' },
        { key: 'fullName', sortable: true, label: 'Full Name' },
        { key: 'category', sortable: true, label: 'Category' },
        { key: 'passport', sortable: true, label: 'Passport' },
        { key: 'signature', sortable: true, label: 'Signature' },
      ],
      memoListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', label: 'Account Number' },
        { key: 'actionType', label: 'Action Type' },
        { key: 'details', label: 'Reason' },
        { key: 'comments', label: 'Comments' },
        { key: 'initiatedBy', label: 'Initiated By' },
      ],
      memoGetData: [],
    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
    }),
    hasSelectedSignatory() {
      return !this.selectedSignatories.length
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedMandateListHeaders() {
      return this.mandateListHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedSignatoryListHeader() {
      return this.signatoryListHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedMemoListHeaders() {
      return this.memoListHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    this.fetchBillTypes()
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      getUserBalance: 'account/getCASABalanceAction',
      getBillTypes: 'eChannels/getBillTypeList',
      getBillsCustomerName: 'eChannels/getBillsCustomerNameAction',
      performBillsPayment: 'eChannels/performBillsPayment',
      getAccountSignatories: 'account/getAccountSignatoriesAction',
      getByAccountNumber: 'account/getByAccountNumber',
    }),
    onViewSignatoryMandate() {
      this.$refs.makeBillsPayRules.validate().then(success => {
        if (success) {
          this.$root.$emit('bv::show::modal', 'signatory-mandate-table')
        }
      })
    },
    onSelect(value) {
      if (value) {
        this.selectedSignatories.push(value)
      } else {
        this.selectedSignatories.pop()
      }
    },
    async fetchAccountSignatories({ accountNumber }) {
      try {
        const response = await this.getAccountSignatories({ accountNumber, permission: 'INITIATE_TRANSFER' })

        if (response.status === 200 && response.data.data) {
          this.signatoryList = response.data.data.map(item => ({
            fullName: item.name,
            passport: item.passportFileUrl,
            signature: item.signatureFileUrl,
            category: item.category,
            select: false,
          }))
        } else {
          this.signatoryList = []
          this.signatoryMandateList = []
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    onViewPassport(image, name) {
      this.avatarLg = image
      const passport = this.$t('Passport')
      this.avatarModalTitle = `${name}'s ${passport}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    onViewSignature(image, name) {
      this.avatarLg = image
      const signature = this.$t('Signature')
      this.avatarModalTitle = `${name}'s ${signature}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    resetAvatarModal() {
      this.avatarLg = ''
      this.avatarModalTitle = ''
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: 'VIEW_BILLS_PAYMENT_HISTORY',
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        this.showBackButton = true
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: 'VIEW_BILLS_PAYMENT_HISTORY' })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            ledgerBalance: toBalance(data.ledgerBalance),
            originalWithdrawableBalance: data.withdrawableBalance,
          }
          this.billsPaymentFormData = {
            accountNumber: customer.accountNumber,
            // customerName: customer.customerName,
            transactionChannel: 3,
          }
          if (data.memos !== null) {
            this.memoGetData = data.memos
            this.$root.$emit('bv::show::modal', 'memo-info-modal')
          }
          await this.fetchAccountSignatories({ accountNumber: customer.accountNumber })
          const accountResponse = await this.getByAccountNumber({ accountNumber: customer.accountNumber, permission: 'VIEW_BILLS_PAYMENT_HISTORY' })
          if (accountResponse.status === 200 && accountResponse.data.data) {
            this.mandateList = transformMandateRule(accountResponse.data.data.mandateRuleIndex)
          }
        }
        this.showCustomerInfo = true
        this.showSearchButton = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async fetchBillTypes() {
      try {
        const response = await this.getBillTypes({
          permission: 'VIEW_BILLS_PAYMENT_HISTORY',
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.allBillers = data.data
          this.billTypeOptions = data.data.map(item => ({
            label: item.name,
            value: item.id,
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    setBillersCategory(id) {
      this.billerId = id
      this.selectedBillers = []
      this.allBillers.forEach(item => {
        const selectBillers = item.billers.filter(idd => idd.billerCategoryId === id)
        if (item.billers.filter(idd => idd.billerCategoryId === id).length > 0) {
          this.selectedBillers.push(selectBillers)
        }
      })
    },
    fetchBillerPackage(billType, billName, identifier, packages) {
      this.billsPaymentFormData.billerIdentifier = identifier
      this.billerType = billType
      this.billerName = billName
      if (packages) {
        if (billType === 'Collections' || billType === 'Internet' || billType === 'CableTv') {
          this.packageOptions = packages.map(item => ({
            label: `${item.name} - ${toBalance(item.amount)}`,
            value: item.identifier,
          }))
        } else {
          this.packageOptions = packages.map(item => ({
            label: item.name,
            value: item.identifier,
          }))
        }
      }
      this.selectedPackages = packages
      this.billsPaymentFormData.customerId = ''
      this.billsPaymentFormData.amount = 0
      this.billsPaymentFormData.customerName = ''
      this.$root.$emit('bv::show::modal', 'bills-payment-modal')
    },
    checkAmountValue(amount) {
      this.isInsufficientFund = formatAmount(this.customer.originalWithdrawableBalance) > amount
      if (!this.isInsufficientFund) {
        this.alertError({ text: this.$t('Insufficient Funds') })
      }
    },
    setBillsPackageValue(value) {
      const filteredAmount = this.selectedPackages.filter(item => item.identifier === value).reduce((acc, cur, i) => {
        acc[i] = cur
        return acc
      }, {})
      // eslint-disable-next-line prefer-destructuring
      this.billsPaymentFormData.amount = formatAmount(filteredAmount[0].amount)
      this.filteredBillerName = filteredAmount[0].name
      this.orignalfilteredBillerName = filteredAmount[0].name
    },
    async setBillerCustomerName() {
      try {
        this.showSpinner = true
        const formData = {
          globalBillerIdentifier: this.billsPaymentFormData.billerIdentifier,
          productName: this.billsPaymentFormData.packageIdentifier,
          customerId: this.billsPaymentFormData.customerId,
        }
        const response = await this.getBillsCustomerName({
          formData, permission: 'MAKE_BILLS_PAYMENT',
        })
        const { data } = response
        if (data.customer !== null) {
          this.billsPaymentFormData.customerName = data.customer.customerName ? data.customer.customerName : `${data.customer.firstName} ${data.customer.lastName}`
          this.showSpinner = false
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    async checkCustomerBillsPayment() {
      // await this.setBillerCustomerName()
      this.$refs.makeBillsPayRules.validate().then(async success => {
        if (success) {
          await this.setBillerCustomerName()
          if (this.billsPaymentFormData.customerName) {
            this.billerPackage = removeUnderscore(this.billsPaymentFormData.packageIdentifier)
            this.$root.$emit('bv::show::modal', 'confirm-bills-payment-modal')
            this.allBillsPaymentData = {
              ...this.billsPaymentFormData,
            }
            this.hideModal('bills-payment-modal')
          }
        }
      })
    },
    async handleBillsPayment() {
      this.$refs.makeBillsPayRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to purchase')
          const ofText = this.$t('of')
          const toText = this.$t('to')
          const onText = this.$t('on')
          const forText = this.$t('for')
          if (this.billerType === 'Airtime') {
            this.confirm(this.makeBillsPayment, { text: `${areYouSure} ${this.billerName} ${ofText} ${toBalance((this.billsPaymentFormData.amount * 100))} ${toText} ${this.billsPaymentFormData.customerId}?` })
          } else if (this.billerType === 'Internet') {
            this.confirm(this.makeBillsPayment, { text: `${areYouSure} ${this.filteredBillerName} ${ofText} ${toBalance((this.billsPaymentFormData.amount * 100))} ${toText} ${this.billsPaymentFormData.customerId} ${onText} ${this.billerName}?` })
          } else if (this.billerType === 'CableTv') {
            this.confirm(this.makeBillsPayment, { text: `${areYouSure} ${this.billerName} ${forText} ${toBalance((this.billsPaymentFormData.amount * 100))} ${toText} ${this.billsPaymentFormData.customerId} ${onText} ${this.orignalfilteredBillerName}?` })
          } else if (this.billerType === 'Collections') {
            this.confirm(this.makeBillsPayment, { text: `${areYouSure} ${this.billerName} ${forText} ${toBalance((this.billsPaymentFormData.amount * 100))} ${toText} ${this.billsPaymentFormData.customerId} ${onText} ${this.orignalfilteredBillerName}?` })
          } else if (this.billerType === 'Electricity') {
            this.confirm(this.makeBillsPayment, { text: `${areYouSure} ${this.billerName} ${forText} ${toBalance((this.billsPaymentFormData.amount * 100))} ${toText} ${this.billsPaymentFormData.customerId} ${onText} ${this.orignalfilteredBillerName}?` })
          } else if (this.billerType === 'Betting') {
            this.confirm(this.makeBillsPayment, { text: `${areYouSure} ${this.billerName} ${forText} ${toBalance((this.billsPaymentFormData.amount * 100))} ${toText} ${this.billsPaymentFormData.customerId} ${onText} ${this.orignalfilteredBillerName}?` })
          } else {
            this.confirm(this.makeBillsPayment, { text: `${areYouSure} ${this.billerName} ${forText} ${toBalance((this.billsPaymentFormData.amount * 100))}?` })
          }
        }
      })
    },
    async makeBillsPayment() {
      try {
        if (this.billerType === 'Airtime') {
          this.getPackageIdentifier = this.packageOptions.reduce((acc, item) => ({ ...acc, identifier: item.value }), {})
        }
        this.showSpinner = true
        const formData1 = {
          ...this.allBillsPaymentData,
          packageIdentifier: this.allBillsPaymentData.packageIdentifier ? this.allBillsPaymentData.packageIdentifier : this.getPackageIdentifier.identifier,
          customerName: this.allBillsPaymentData.customerName ? this.allBillsPaymentData.customerName : this.allBillsPaymentData.customerId,
          amount: this.allBillsPaymentData.amount ? toKobo(this.allBillsPaymentData.amount) : '',
          paymentReference: uuidv4(),
        }
        const formData2 = {
          ...this.billsPaymentFormData,
          packageIdentifier: this.billsPaymentFormData.packageIdentifier ? this.billsPaymentFormData.packageIdentifier : this.getPackageIdentifier.identifier,
          customerName: this.billsPaymentFormData.customerName ? this.billsPaymentFormData.customerName : this.billsPaymentFormData.customerId,
          amount: this.billsPaymentFormData.amount ? toKobo(this.billsPaymentFormData.amount) : '',
          paymentReference: uuidv4(),
        }
        const formData = this.billerType === 'Airtime' || this.billerType === 'Internet' ? formData2 : formData1
        const response = await this.performBillsPayment({ formData, permission: 'MAKE_BILLS_PAYMENT' })
        const { status, data } = response
        if (status === 200 && data.isSuccessful) {
          this.showSpinner = false
          this.hideModal('bills-payment-modal')
          const yourText = this.$t('Your')
          const purchaseText = this.$t('purchase request was successful')
          this.alertSuccess({ text: `${yourText} ${this.billerName} ${purchaseText}` })
          this.resetModal()
          this.$router.push({ name: 'bills-payment' })
        } else {
          this.alertError({ text: data.responseMessage })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.customerID = null
      this.searchParams.referenceNumber = null
    },
    resetModal() {
      this.billsPaymentFormData.packageIdentifier = ''
      this.billsPaymentFormData.customerId = ''
      this.billsPaymentFormData.amount = 0
      this.filteredBillerName = ''
    },
    resetPackageIdentifier() {
      this.billsPaymentFormData.packageIdentifier = ''
      this.filteredBillerName = ''
    },
    resetAirtimeData() {
      if (this.billerType === 'Airtime' || this.billerType === 'Internet') {
        this.billsPaymentFormData.packageIdentifier = ''
        this.filteredBillerName = ''
      } else {
        this.billsPaymentFormData.packageIdentifier = ''
        this.filteredBillerName = ''
      }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'bills-payment',
      })
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}

.button-center {
  display: flex;
  justify-content: center;
}
.format-cards {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); /* this adds the "card" effect */
  border: 4px solid #f1f1f1 !important;
  border-radius: 0.458rem;
  cursor: pointer;
}
.format-cards div {
  display: flex;
}
.format-cards .card-inner {
  min-width: 25%;
  margin-right: 5px;
}
.format-cards :hover {
  background-color: #b1a6a6;
}
.brand-logo {
  max-width: 70px;
  max-height: 70px;
}
.card-title {
  font-family: Century Gothic, sans-serif;
  font-size: 1.1rem;
  margin-top: 5px;
  font-weight: bold;
}
.card-subtitle {
  font-family: Century Gothic, sans-serif;
  font-size: 1rem;
  margin-top: -15px;
}
</style>
